import {Pipe, PipeTransform} from '@angular/core';
import {IconSize} from '../../bfa-api/models/icon-size';
import {IconService} from '../../services/icon/icon.service';
import {STATIC_CONFIGS} from '../../../configs/static.config';

@Pipe({
    name: 'apiVaultIconUrl',
    pure: true
})
export class ApiVaultIconUrlPipe implements PipeTransform {
    public transform(vaultId: string | null | undefined, iconSize: IconSize = STATIC_CONFIGS.ui.defaultIconFetchSize): string | undefined | null {
        return vaultId ? IconService.getVaultIconUrl(vaultId, iconSize) : vaultId;
    }
}
